<template>
  <div class="contenedor-referencias-bibliograficas">
    <div class="encabezado" :class="{'border-bottom-none': tieneVistaSimplificada}">
      <h2>{{ titulo }}</h2>
    </div>

    <ul class="lista-referencias" :class="{'max-height-inherit': tieneVistaSimplificada}">
      <li
        v-for="(val, idx) in referencias"
        :key="`referrencias_${idx}`"
        v-html="val"
      />
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
    },
    referencias: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    tieneVistaSimplificada(){
      return this.$store.getters.tieneVistaSimplificada;
    }
  }
};
</script>

<style lang="scss">
.contenedor-referencias-bibliograficas {
  .encabezado {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #000;
    &.border-bottom-none {
      border-bottom: none;
    }
    h2 {
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
    }
    a.btn {
      height: 40px;
      padding: 10px 25px;
      background-color: #9d4637;
    }
  }
  .lista-referencias {
    word-wrap: anywhere;
    margin-top: 0;
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
    &.max-height-inherit {
      max-height: inherit;
    }
    &:hover {
      background: transparent;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      &:hover {
        background: #F5F5F5;
      }      
    }
    li {
      font-size: 14px;
      margin: 0 8px;
      padding: 8px 0;
      > * {
        font-size: 14px;
      }
      &::before {
        margin-right: 4px;
      }
    }
  }
}
</style>
